import React from 'react';

import { TranslationKeys } from 'app/translations';

import ActionButton from '../../../../../components/ActionButton';

type InsurerActionsProps = {
  disabled: boolean;
  onClick: () => void;
};

export const InsurerActions = ({ disabled, onClick }: InsurerActionsProps) => {
  return <ActionButton messageId={TranslationKeys.insurers_edit} disabled={disabled} onClick={onClick} />;
};
